module.exports = __webpack_public_path__ + "static/img/2.f1a21fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 4